import { BankBicEnum } from '.spec/self-care/tsTypes';
import { Image } from '@mallpay/orbis';
import React from 'react';

import { mergeClasses } from '@skippay/core/utils/classUtils';

import { bankIdLogos } from 'constants/banksList';

interface BankProps {
	light: string;
	dark: string;
	alt: string;
}

const Bank: React.FC<BankProps> = ({ light, dark, alt }) => {
	return (
		<div className="flex flex-col items-center">
			<Image src={light} objectFit="scale-down" alt={alt} className="d-dark-none h-6" />
			<Image src={dark} objectFit="scale-down" alt={alt} className="d-dark-block h-6" />
		</div>
	);
};

interface BanksListProps {
	banks: BankBicEnum[];
	className?: string;
}

const BanksList: React.FC<BanksListProps> = ({ banks, className }) => {
	return (
		<div className={mergeClasses('flex flex-wrap justify-center gap-x-8 gap-y-4', className)}>
			{banks.map((bank) => (
				<Bank key={bank} alt={bank} light={bankIdLogos[bank].light} dark={bankIdLogos[bank].dark} />
			))}
		</div>
	);
};

export default BanksList;
